import { Button, ButtonStyle, DEFAULT_HEADING, DEFAULT_SUBHEADING, EditImage, EdiText, Form, Formik, 
         Checkbox, Select, getCustomizeCareerData, handleBackgroundOnChange, PageStyle, 
         updateHeader, updateSubheader,  useEffect, useRouter, useState, 
         ClientDashboard, SkipModal, ActivitiesAction, ErrorPages, SidebarAction, useSWR, 
         useTranslation}  from '@/imports-files/pages/clients/careers/createJob';


function CustomizeCareer(props) 
{
  const router                                       =     useRouter();
  const [apiError, setApiError]                      =     useState(null);
  const errorPages                                   =     new ErrorPages()
  const activitiesAction                             =     new ActivitiesAction(setApiError);
  const { data, error }                              =     useSWR('customize_career_data', () => { return(getCustomizeCareerData(router, setApiError))});
  const [valueHeading, setValueHeading]              =     useState(DEFAULT_HEADING);
  const [valueSubheading, setValueSubheading]        =     useState(DEFAULT_SUBHEADING);
  const [isLoading, setLoadingStatus]                =     useState(true);
  const [jobOptions, setJobOptions]                  =     useState('');
  const [locationOptions, setLocationOptions]        =     useState('');
  const [editingHeading, setHeadingEditing]          =     useState(false);
  const [editingSubHeading, setSubHeadingEditing]    =     useState(false);
  const [newbackgroundImage, setBackgroundImage]     =     useState('/images/pages/career/careerbg.png');
  const { t, i18n }                                  =     useTranslation();
  const step                                         =     router.query.step
  const isQuickSetup                                 =     router.query.step && router.query.step == 'careers_page' ? true : false
  const [skipModal, setSkipModal]                    =     useState(false);


  useEffect(()=>{
                    if(data)
                    {
                      data?.career_page?.heading ? setValueHeading(data.career_page.heading) : '';
                      data?.career_page?.sub_heading ? setValueSubheading(data.career_page.sub_heading) : '';
                      newbackgroundImage.includes('blob:') ?  '' :  ( data?.career_page?.bg_image_url ? setBackgroundImage(data.career_page.bg_image_url) : '') ;
                      setLoadingStatus(false);

                      if(isQuickSetup) 
                        setTimeout(() => {
                        new SidebarAction().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, 'careers_page');
                     }, 750);
                    }
                },[data]);
                

  
  if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage; 
  } 


  if (isLoading)
  {
     return null;
  } 

 return (
    <div className={`CustomizeCareer ${PageStyle.CustomizeCareer__Container}`}>
      
      <div className={`Career_Background  ${PageStyle.CustomizeCareer}`}>
      <img    src       = {newbackgroundImage}
              alt       = 'back-image'
              className = "background-image"
      />
      
      <div className  = {`${PageStyle.CustomizeCareer__Inner}`}>

         <div className = {`${PageStyle.CustomizeCareer__Background_Edit}`}> 
            <label htmlFor     =   "background-file-input" className = {'background-edit-icon'}>
              <img  alt        =   "edit-image" 
                    src        =   '/icons/edit.png' 
                    className  =   {PageStyle.CustomizeCareer__Background_Edit_Image}
              />
            </label>

            <input id         =   "background-file-input"  
                   accept     =   ".png, .jpg, .jpeg" 
                   type       =   "file"  
                   onChange   =   { (event) => handleBackgroundOnChange(event, setBackgroundImage)} />
          </div>

         <div className={PageStyle.CustomizeCareer__logo}>
           <EditImage logo_url = {data.career_page?.logo_url}/>
         </div>

         <div className={PageStyle.CustomizeCareer__Content}>
            <h1 onClick={() => setHeadingEditing(() => !editingHeading)}  >
              <EdiText showButtonsOnHover 
                                          className            =   {PageStyle.CustomizeCareer__Heading}
                                          editing              =   {editingHeading}
                                          editButtonClassName  =   "removeEdit"
                                          inputProps           =   {{maxLength:'40'}}
                                          onSave               =   { (val) => updateHeader(val, setValueHeading, setHeadingEditing) }
                                          type                 =   "text" 
                                          value                =   {valueHeading}  
                                          submitOnEnter        =   {true}
              />

              {!editingHeading && <img  alt        =   "edit-image" 
                    src        =   '/icons/edit.png' 
                    className  =   {PageStyle.CustomizeCareer__Background_Edit_Image}
              />}
            </h1>

           <span onClick={() => setSubHeadingEditing(() => !editingSubHeading)} >
              <EdiText showButtonsOnHover 
                      className             =   {PageStyle.CustomizeCareer__Subheading}
                      editing               =   {editingSubHeading}
                      editButtonClassName   =   "removeEdit"
                      inputProps            =   {{maxLength:'70'}}
                      onSave                =   { (val) =>updateSubheader(val, setValueSubheading, setSubHeadingEditing) } 
                      type                  =   "text" 
                      value                 =   {valueSubheading} 
                      submitOnEnter         =   {true}
              />


            {!editingSubHeading && <img  alt        =   "edit-image" 
                    src        =   '/icons/edit.png' 
                    className  =   {PageStyle.CustomizeCareer__Background_Edit_Image}
              />}
           </span>
         </div>
     </div>
      </div>

      <div className={PageStyle.Job}>
        <div className={PageStyle.Job__Inner}>
          <h1 className={PageStyle.Job__Heading}>
          {t('page:clients:customize-career:texts:title')}
            <span className={PageStyle.Job__Company}> 88</span>
          </h1>

          <div className={PageStyle.Job__SearchContainer}>
            <form>
              <div className={PageStyle.DT}>
                  <div className={`${PageStyle.Job__SearchInput}`}>
                    <input
                        type="text"
                        placeholder="e.g. UI Designer"
                        className={PageStyle.Job__Input}
                        name ="search"
                      />
                  </div>
                  <div className={`${PageStyle.Job__Searchbtn}`}>
                    <Button buttonstyle={ButtonStyle.jobsrchbtn}>
                    <img src='/icons/search.png' alt='' className={PageStyle.pd11}></img>
                    </Button>
                  </div>
              </div>
            
            </form>
          </div>

          <div className={PageStyle.Job__SelectJob}>
            <Formik>
              {(formik) => (
                <Form className={PageStyle.Form}>
                  <div className={PageStyle.Form__Table}>
                    <div className={PageStyle.Form__TableRowflex}>
                      <div className={`${PageStyle.Form__TableColm} tablecol80`}>
                        <span className={PageStyle.Form__Label}>  {t('page:clients:customize-career:texts:locations')} </span>

                        <Select className ={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`} options={locationOptions.options}/>
                      </div>

                      <div className={`${PageStyle.Form__TableColm} tablecol80`}>
                        <span className={PageStyle.Form__Label}>  {t('page:clients:customize-career:texts:job_type')} </span>

                        <Select className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto} `} options={jobOptions.options}/>
                      </div>   

                      <div className={`${PageStyle.Form__TableColm} ${PageStyle.padt40} tablecol47 alignright mr0`}>
                        <Checkbox
                          value="checkedA"
                          inputProps={{ "aria-label": "Checkbox A" }}
                        />{" "}
                        <span className={PageStyle.Job__RemoteLabel}>
                        {t('page:clients:customize-career:texts:remote_only')}
                        </span>
                      </div>

                    </div>

                  </div>
                </Form>
              )}
            </Formik>
          </div>


          <div className={PageStyle.Job__Display}>
              <span className={PageStyle.Job__PostDay}>
              {t('page:clients:customize-career:texts:posted_today')}
              </span>

              <h3  className={PageStyle.Job__Title}>{t('page:clients:customize-career:texts:post_first')}</h3>

              <ul  className={PageStyle.Job__Location}>
                  <li> {t('page:clients:customize-career:texts:country')}</li>
                  <li> {t('page:clients:customize-career:texts:remote')}</li>
                  <li> {t('page:clients:customize-career:texts:permanent')}</li>

              </ul>
          </div>

          <div className={PageStyle.Job__Display}>
              <span className={PageStyle.Job__PostDay}>
              {t('page:clients:customize-career:texts:posted_today')}
              </span>

              <h3  className={PageStyle.Job__Title}>{t('page:clients:customize-career:texts:post_second')}</h3>

              <ul  className={PageStyle.Job__Location}>
                  <li> {t('page:clients:customize-career:texts:country')}</li>
                  <li> {t('page:clients:customize-career:texts:remote')}</li>
                  <li> {t('page:clients:customize-career:texts:permanent')}</li>

              </ul>
          </div>

          <div className={PageStyle.Job__Display}>
              <span className={PageStyle.Job__PostDay}>
              {t('page:clients:customize-career:texts:posted_today')}
              </span>

              <h3  className={PageStyle.Job__Title}>{t('page:clients:customize-career:texts:post_third')}</h3>

              <ul  className={PageStyle.Job__Location}>
                  <li> {t('page:clients:customize-career:texts:country')}</li>
                  <li> {t('page:clients:customize-career:texts:remote')}</li>
                  <li> {t('page:clients:customize-career:texts:permanent')}</li>

              </ul>
          </div>
        </div>
      </div>

      {/* <div className={PageStyle.CareerFooter}>
        <p>{t('page:clients:customize-career:texts:footer_text')}</p>               
      </div> */}

      {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
      <div className={PageStyle.CareerFooterWithButton}>
        <p>{t('page:clients:customize-career:texts:footer_text')}</p>
        {isQuickSetup && <div className={`buttonolumngap`} style={{display: "grid" , gridTemplateColumns: "175px 175px"}}>
          <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" onClick={() => { setSkipModal(true)}}>
            Skip
          </Button>
          <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={()=>{ activitiesAction.nextOnboardingStep(step, router) }}>
            Next
          </Button>
        </div>}
      </div>

    </div>

)
}

CustomizeCareer.layout = ClientDashboard;
export default CustomizeCareer;